(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'Principal'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Principal) {
        var vm = this;

        vm.authoritiesConstant = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPPLIER', 'ROLE_MANAGER', 'ROLE_CUSTOMER_MANAGER', 'ROLE_FINANCIAL_MANAGER', 'ROLE_RESERVATION_MODIFIER', 'ROLE_RESERVATION_MANAGER', 'ROLE_SERVANT_MANAGER', 'ROLE_CATEGORY_MANAGER', 'ROLE_COMPANY_MANAGER', 'ROLE_OFFICE_MANAGER', 'ROLE_SERVANT_LOGIN', 'ROLE_REPORT_MANAGER', 'ROLE_DENY_REPORT_MANAGER', 'ROLE_FREEMIUM_USER', 'ROLE_EVENT_MANAGER', 'ROLE_SUPER_ADMIN_BASIC_ACCESS', 'ROLE_SUPER_ADMIN_ADVANCED_ACCESS', 'ROLE_SUPER_ADMIN_FULL_ACCESS'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.authorities = [];
        vm.isAdmin = Principal.hasAnyAuthority(["ROLE_SUPER_ADMIN_FULL_ACCESS"]);

        loadAuthorities();

        function loadAuthorities() {

            angular.forEach(vm.authoritiesConstant, function (auth) {
                var authObj = {};
                authObj.key = auth;
                authObj.value = false;
                authObj.disable = false;
                angular.forEach(vm.user.authorities, function (userAuth) {
                    if (authObj.key == userAuth)
                        authObj.value = true;
                })

                if (!vm.isAdmin
                    && (authObj.key == "ROLE_SUPER_ADMIN_BASIC_ACCESS"
                        || authObj.key == "ROLE_SUPER_ADMIN_ADVANCED_ACCESS"
                        || authObj.key == "ROLE_SUPER_ADMIN_FULL_ACCESS"
                    )
                ) {
                    authObj.disable = true;

                }

                vm.authorities.push(authObj);
            })
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            createUserAuthorities();
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function createUserAuthorities() {
            vm.user.authorities = [];
            angular.forEach(vm.authorities, function (auth) {
                if (auth.value)
                    vm.user.authorities.push(auth.key);
            })
        }

    }
})();
